import { useRef } from "react";
import { core } from "smartystreets-javascript-sdk";
import type { SmartyStreetsHook } from "./types";

const useSmartyStreets = (authToken: string): SmartyStreetsHook => {
  // Using refs to prevent instantiating new instances on each render
  const smartyStreetsSharedCredentials = useRef(
    new core.SharedCredentials(authToken)
  );

  /** Used for fetching AutoComplete Suggestions */
  const autoCompleteClientBuilder = useRef(
    new core.ClientBuilder(smartyStreetsSharedCredentials.current)
  );
  const autoCompleteClient = useRef(
    autoCompleteClientBuilder.current.buildUsAutocompleteClient()
  );

  /** Used for verifying a selected Address Candidate */
  const usStreetClientBuilder = useRef(
    new core.ClientBuilder(smartyStreetsSharedCredentials.current)
  );
  const usStreetClient = useRef(
    usStreetClientBuilder.current.buildUsStreetApiClient()
  );

  return {
    autoCompleteClient,
    usStreetClient
  };
};

export default useSmartyStreets;
